import { ICourseSchedulingListItem } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
import React, { FC, ReactElement } from 'react'

interface ICertificationControlWrapperBase {
  courseScheduling: ICourseSchedulingListItem
  children: ReactElement
}

interface ICertificationControlWrapperPropsMultiple extends ICertificationControlWrapperBase {
  showOnMultipleCertificate: boolean
  showOnNormalCertificate?: never
}

interface ICertificationControlWrapperPropsNormal extends ICertificationControlWrapperBase {
  showOnNormalCertificate: boolean
  showOnMultipleCertificate?: never
}

type ICertificationControlWrapperProps = ICertificationControlWrapperPropsMultiple | ICertificationControlWrapperPropsNormal

const CertificationControlWrapper: FC<ICertificationControlWrapperProps> = ({
  children,
  courseScheduling,
  showOnMultipleCertificate,
  showOnNormalCertificate,
}) => {
  if (courseScheduling?.multipleCertificate?.status && showOnNormalCertificate) return null
  if (!courseScheduling?.multipleCertificate?.status && showOnMultipleCertificate) return null
  return children
}

export default CertificationControlWrapper
